import { useEffect, useState } from 'react'
import Button from '../../button/Button'

import Plus from "@untitled-ui/icons-react/build/esm/Plus"
import { Carrier } from '../../../models/Carrier'
import { DropdownOption } from '../../../models/DropdownOption'
import { getCurrencySymbolUtil } from '../../../utils/CommonUtil'
import MultiSelectDropdown from '../../input/MultiSelectDropdown'
import Popup from '../../popup/Popup'

type Props = {
    value: string[],
    setValue: (value: string[]) => void,
    surcharges: any[] | undefined,
    carrier: Carrier
}

const getSurchargeName = (surcharge: any, carrier: Carrier) => {
        let name = surcharge.name;
        if (surcharge.eventSettings.valueType === "FLAT_COST") {
            name = name + " (" + surcharge.eventSettings.value + "" + getCurrencySymbolUtil(carrier.currency) + ")"
        } else {
            name = name + " (" + surcharge.eventSettings.value + "%)"
        }
        return name;
    }

const AdditionalServicesSelection = ({ value, setValue, surcharges, carrier }: Props) => {

    const [isListVisible, setIsListVisible] = useState(false)
    const [options, setOptions] = useState<DropdownOption[]>([])
    const [selectedIds, setSelectedIds] = useState<DropdownOption[]>([])

    useEffect(() => {
        console.log(value)
        setSelectedIds(options?.filter(item => value.includes(item.value)) || [])
    }, [value])
    
    useEffect(() => {
        if (surcharges?.length) {
             const options: DropdownOption[] = surcharges.map((surcharge) => {
                return {
                    label: getSurchargeName(surcharge, carrier),
                    value: surcharge.id,
                    optionGroup: surcharge.ruleKey
                }
            })
            setOptions(options)
        }
    }, [surcharges])

    const handleDropdownChange = (newSelectedOptions: DropdownOption[]) => {
        const previousValues = selectedIds.map((item) => item.value)
        const newValues = newSelectedOptions.map((item) => item.value)

        const addedOption = newSelectedOptions.find((item) => !previousValues.includes(item.value))
        const removedOption = selectedIds.find((item) => !newValues.includes(item.value))

        let updatedSelections: DropdownOption[] = [...newSelectedOptions]

        if (addedOption) {
            const groupOptions = options.filter((opt) => opt.optionGroup === addedOption.optionGroup)
            updatedSelections = Array.from(new Set([...newSelectedOptions, ...groupOptions]))
        } else if (removedOption) {
            updatedSelections = newSelectedOptions.filter((opt) => opt.optionGroup !== removedOption.optionGroup)
        }

        setSelectedIds(updatedSelections)
        // setValue(updatedSelections.map((option) => option.value))
    }

    const renderContent = () => (
        <div className="w-full gap-2 pb-60">
            <MultiSelectDropdown
                options={options}
                values={selectedIds}
                handleChange={handleDropdownChange}
                placeholder="Search surcharges"
                displayValueTagsLimit={10}
            />
        </div>
    )

    return (
        <>
            <div className="flex items-center gap-2">
                <Button
                    buttonType={6}
                    className="!text-sm font-semibold w-fit !text-primary_color"
                    icon={<Plus className="w-5 h-5" />}
                    label={"Additional Services"}
                    onClick={() => setIsListVisible((prev) => !prev)}
                />
                {selectedIds.length > 0 && <p className=" text-sm font-normal text-text_secondary_color">({options.find(item => item.value === selectedIds[0].value)?.label}{selectedIds.length > 1 ? ` & ${selectedIds.length - 1} more` : ""})</p>}
            </div>

            <Popup
                isOpen={isListVisible}
                title="Additional Services"
                message='Select any additional services you require for your shipment. Please note that additional services may incur additional cost that may or may not be fully disclosed below.'
                type="info"
                onClosePopUp={() => {
                    setIsListVisible(false)
                    setSelectedIds(options?.filter(item => value.includes(item.value)))
                }}
                primaryButtonLabel="Save"
                primaryButtonAction={() => {
                    setValue(selectedIds.map((option) => option.value))
                    setIsListVisible(false)
                }}
                content={renderContent()}
            />
        </>
    )
}

export default AdditionalServicesSelection